import { useSettingsContext } from "../../../../../settings/context";
import { useDataTableContext } from "../../../context";
import { type DataTablePreferenceProfileSettingsType } from "../types";

export function useApplyPreferenceProfile() {
  const { preferences } = useSettingsContext();
  const table = useDataTableContext();

  const applyPreferenceProfile = async (
    profile: { id: string; name: string },
    settings?: DataTablePreferenceProfileSettingsType,
  ) => {
    table.applyProfile(settings);

    await preferences.set({
      key: table.tableId,
      preferences: {
        version: table.version,
        profile,
      },
    });

    await preferences.refresh();
  };

  return applyPreferenceProfile;
}
